// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"c19663e2","281":"a86734be","546":"7c31ffb2","864":"03067b25","877":"6425920a","902":"6dad5a52","913":"9f210499","914":"f1cd49cb","979":"b2280caa","997":"255801e3"}[chunkId] + ".chunk.js";
};